import { useMediaQuery, useTheme } from '@material-ui/core'

export const useIsMobile = () => {
  const theme = useTheme()
  const isAboveMobile = useMediaQuery(theme.breakpoints.up('mobile'), {
    noSsr: true,
  })
  return !isAboveMobile
}

export const useIsTablet = () => {
  const theme = useTheme()
  const isAboveTablet = useMediaQuery(theme.breakpoints.up('tablet'), {
    noSsr: true,
  })
  return !isAboveTablet
}

export const fileToBase64 = file => {
  if (file instanceof Blob) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => resolve(reader.result)
      reader.onerror = error => reject(error)
    })
  }
}

export const mapToOptions = ({ id, name }) => ({
  value: id,
  label: name,
})

export const mapArrayErrorsToObject = (
  errorsArray,
  paramsArray,
  idKey,
  getError = err => err
) =>
  errorsArray.reduce((errors, fieldError, idx) => {
    if (Object.keys(fieldError).length > 0) {
      const fieldId = paramsArray[idx][idKey]
      errors[fieldId] = getError(fieldError)
    }
    return errors
  }, {})

export const getFileParam = async file =>
  file instanceof File ? await fileToBase64(file) : file || null
